import { InjectionToken, Provider } from '@angular/core';

import { Environment } from '@stress/environments/env';
import { environment } from '@stress/environments/environment';

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');

export const environmentProvider: Provider = {
  provide: ENVIRONMENT,
  useValue: environment,
};
